import { routes as procedureQueueRoutes } from "./procedure-queue/routes";
import { routes as operationNotes } from "./operation-notes/routes";
import { routes as theatreQueueRoutes } from "./theatre-queue/routes";
import { routes as pastQueueRoutes } from "./past-queue/routes";
import { routes as completedProcedureRoutes } from "./previous-procedures/routes";
import { routes as procedurelistRoutes } from "./procedure-list/routes";

export const routes = [

    ...theatreQueueRoutes(),
    ...procedureQueueRoutes(),
    ...operationNotes(),
    ...completedProcedureRoutes(),
    ...pastQueueRoutes(),
    ...procedurelistRoutes(),
];
